import { FunctionComponent, useCallback } from 'react'
import Modal from '@/components/Modal'
import { Text } from '@conexasaude/conexa-hero'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useRealtimeAttendanceContext } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import { useStyles } from './styles'
import { useFirebaseContext } from '@/modules/Firebase/contexts/FirebaseContext'
import { useNavigation } from '@/hooks/useNavigation'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { roomPaths } from '@/modules/Attendance/submodules/Room/constants'
import { useCurrentAppointment } from '../../hooks/use-current-appointment'

const AttendanceStartedModal: FunctionComponent = () => {
  const { closeModal } = useModalContext()

  const {
    realtimeAttendance: { nextScheduled },
  } = useRealtimeAttendanceContext()
  const styles = useStyles()
  const { logAnalyticsEvent } = useFirebaseContext()
  const navigate = useNavigation()

  const { clinic } = useAuthContext()

  const { getCurrentAppointment } = useCurrentAppointment()

  const goAppointmentScheduledWithAnalytics = useCallback(async () => {
    const currentAppointmentId = nextScheduled?.id
    const currentParams = currentAppointmentId ? '?o=ep' : ''

    let currentWaitingRoomRoute = `/atendimento-agendado/sala-de-espera/${currentAppointmentId}${currentParams}`

    if (clinic?.flag.NovaSalaDeEspera) {
      const currentAppointment = await getCurrentAppointment({
        mode: 'scheduled',
        appointmentId: parseInt(currentAppointmentId),
      })

      if (currentAppointment?.roomId) {
        currentWaitingRoomRoute = `${roomPaths.scheduled.basePath}/${currentAppointment?.roomId}/${currentAppointmentId}${currentParams}`
      }
    }

    logAnalyticsEvent('Pac_Consulta_AcessarConsulta')
    closeModal()
    navigate(currentWaitingRoomRoute)
  }, [
    clinic?.flag.NovaSalaDeEspera,
    closeModal,
    getCurrentAppointment,
    logAnalyticsEvent,
    navigate,
    nextScheduled?.id,
  ])

  const closeModalWithAnalytics = () => {
    logAnalyticsEvent('Pac_Consulta_Fechar')
    closeModal()
  }

  return (
    <Modal
      id="ATTENDANCE_STARTED"
      primaryActionLabel="Acessar consulta"
      primaryAction={goAppointmentScheduledWithAnalytics}
      negativeActionLabel="Fechar"
      negativeAction={closeModalWithAnalytics}
    >
      <div css={styles.wrapperModal}>
        <Text>Sua consulta começará em alguns minutos.</Text>
      </div>
    </Modal>
  )
}

export default AttendanceStartedModal
